import { makeInteractiveColorToken } from "../css/token.color.interactive";
import { makeColorToken } from "../css/token.color";
import { makeSelectors } from "../css/maker.selectors";

export const staticColors = {
  primary: "9 11 25",
  publisher: "255 98 0",
  accent: "73 131 0",
  tertiary: "236 236 238",
  text: "9 11 25",
  textInversed: "255 255 255",
} as const;

const gray = {
  sim100: makeColorToken("--gray-100", "9 11 25"),
  sim65: makeColorToken("--gray-65", "95 96 106"),
  sim40: makeColorToken("--gray-40", "152 154 168"),
  sim30: makeColorToken("--gray-30", "181 182 186"),
  sim20: makeColorToken("--gray-20", "206 206 209"),
  sim15: makeColorToken("--gray-15", "217 217 217"),
  sim10: makeColorToken("--gray-10", "229 230 231"),
  sim06: makeColorToken("--gray-6", "240 240 241"),
  sim03: makeColorToken("--gray-3", "247 247 247"),
  sim02: makeColorToken("--gray-2", "250 250 250"),
  sim00: makeColorToken("--gray-0", "255 255 255"),

  alpha100: makeColorToken("--gray-alpha-100", "9 11 25"),
  alpha65: makeColorToken("--gray-alpha-60", "9 11 25 / 0.65"),
  alpha50: makeColorToken("--gray-alpha-40", "9 11 25 / 0.5"),
  alpha40: makeColorToken("--gray-alpha-40", "9 11 25 / 0.4"),
  alpha30: makeColorToken("--gray-alpha-30", "9 11 25 / 0.3"),
  alpha20: makeColorToken("--gray-alpha-20", "9 11 25 / 0.2"),
  alpha15: makeColorToken("--gray-alpha-15", "9 11 25 / 0.15"),
  alpha10: makeColorToken("--gray-alpha-10", "9 11 25 / 0.1"),
  alpha06: makeColorToken("--gray-alpha-06", "9 11 25 / 0.06"),
  alpha03: makeColorToken("--gray-alpha-03", "9 11 25 / 0.03"),
  alpha02: makeColorToken("--gray-alpha-02", "9 11 25 / 0.02"),
  alpha00: makeColorToken("--gray-alpha-00", "9 11 25 / 0"),
};

const primary = makeColorToken("--primary", staticColors.primary);
const accent = makeColorToken("--accent", staticColors.accent);
const tertiary = makeColorToken("--tertiary", staticColors.tertiary);

const text = {
  primary: gray.sim100.__extend("--text-primary"),
  secondary: gray.sim65.__extend("--text-secondary"),
  inactive: gray.sim40.__extend("--text-inactive"),
  inversed: makeColorToken("--text-inversed", staticColors.textInversed),
};

const interactiveText = {
  primaryOnHover: makeInteractiveColorToken("--interactive-text-primary", {
    default: text.primary,
    hover: primary,
    active: primary,
  }),

  accentOnHover: makeInteractiveColorToken("--interactive-text-accent", {
    default: text.primary,
    hover: accent,
    active: accent,
  }),

  link: makeInteractiveColorToken("--interactive-text-link", {
    default: "27 35 175",
    hover: text.primary,
    active: text.primary,
  }),
};

export const colors = {
  publisher: makeColorToken("--publisher", staticColors.publisher),
  primary,
  accent,
  tertiary,
  white: gray.sim00,
  black: gray.sim100,
  gray,
  text,
  interactiveText,
  bg: makeColorToken("--background", "255 255 255"),

  success: makeColorToken("--success", "66 132 0"),
  warning: makeColorToken("--warning", "188 135 0"),
  danger: makeColorToken("--danger", "182 0 0"),
  notification: makeColorToken("--notification", "232 2 0"),
  info: makeColorToken("--info", "231 255 220"),

  selectors: {
    primary: makeSelectors({
      isLight: "primary--light",
      isDark: "primary--dark",
    }),
    accent: makeSelectors({
      isLight: "accent--light",
      isDark: "accent--dark",
    }),
  },
};
